"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Encoder = void 0;
const Encoder_1 = require("../../../../json-crdt-patch/batch/codec/binary/Encoder");
class Encoder extends Encoder_1.Encoder {
    encodeDelta(delta) {
        const writer = this.writer;
        writer.reset();
        this.writeDelta(delta);
        return writer.flush();
    }
    writeDelta(delta) {
        const writer = this.writer;
        this.writeAny(delta.meta);
        writer.vv(delta.vv0.vv());
        writer.vv(delta.vv1.vv());
        this.writeBatch(delta.batch);
    }
}
exports.Encoder = Encoder;
